import { render } from "./SocialPost.vue?vue&type=template&id=0e2489dc&scoped=true"
import script from "./SocialPost.vue?vue&type=script&lang=js"
export * from "./SocialPost.vue?vue&type=script&lang=js"

import "./SocialPost.vue?vue&type=style&index=0&id=0e2489dc&lang=scss"
import "./SocialPost.vue?vue&type=style&index=1&id=0e2489dc&lang=scss&scoped=true"
import "./SocialPost.vue?vue&type=style&index=2&id=0e2489dc&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2489dc"]])

export default __exports__